// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .stepper {
  width: 100%;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup .stepper.active {
  opacity: 1;
}
.popup .stepper span {
  padding-top: 0%;
  font: 1.7em/1 vigaregular;
  color: #caa36c;
  margin-left: 6%;
  margin-right: 6%;
}
.popup .stepper button {
  border-radius: 50%;
  border: none;
  color: white;
  width: 25px;
  height: 25px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
.popup .stepper button.plus {
  margin-right: 0%;
  background-color: #caa36c;
}
.popup .stepper button.plus:before, .popup .stepper button.plus:after {
  transform: translate(-50%, -50%);
  background-color: #fff;
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
}
.popup .stepper button.plus:before {
  height: 50%;
  width: 2px;
}
.popup .stepper button.plus:after {
  height: 2px;
  width: 50%;
}
.popup .stepper button.minus {
  margin-left: 0%;
  border: 2px solid #caa36c;
  background-color: #fff;
}
.popup .stepper button.minus:before, .popup .stepper button.minus:after {
  transform: translate(-50%, -50%);
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
}
.popup .stepper button.minus:after {
  width: 50%;
  border-top: 2px solid #caa36c;
  border-color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/partials/Stepper.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;AAGQ;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AAFZ;AAIY;EACI,gBAAA;EACA,yBAAA;AAFhB;AAIgB;EAEI,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AAHpB;AAMgB;EACI,WAAA;EACA,UAAA;AAJpB;AAOgB;EACI,WAAA;EACA,UAAA;AALpB;AASY;EACI,eAAA;EACA,yBAAA;EACA,sBAAA;AAPhB;AASgB;EAEI,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AARpB;AAWgB;EACI,UAAA;EACA,6BAAA;EACA,qBAAA;AATpB","sourcesContent":[".popup {\n    .stepper {\n        width: 100%;\n        opacity: .5;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &.active {\n            opacity: 1;\n        }\n\n        span {\n            padding-top: 0%;\n            font: 1.7em/1 vigaregular;\n            color: #caa36c;\n            margin-left: 6%;\n            margin-right: 6%;\n        }\n\n        button {\n            border-radius: 50%;\n            border: none;\n            color: white;\n            width: 25px;\n            height: 25px;\n            text-align: center;\n            text-decoration: none;\n            display: inline-block;\n\n            &.plus {\n                margin-right: 0%;\n                background-color: #caa36c;\n\n                &:before,\n                &:after {\n                    transform: translate(-50%, -50%);\n                    background-color: #fff;\n                    position: absolute;\n                    content: \"\";\n                    left: 50%;\n                    top: 50%;\n                }\n\n                &:before {\n                    height: 50%;\n                    width: 2px;\n                }\n\n                &:after {\n                    height: 2px;\n                    width: 50%;\n                }\n            }\n\n            &.minus {\n                margin-left: 0%;\n                border: 2px solid #caa36c;\n                background-color: #fff;\n\n                &:before,\n                &:after {\n                    transform: translate(-50%, -50%);\n                    position: absolute;\n                    content: \"\";\n                    left: 50%;\n                    top: 50%;\n                }\n\n                &:after {\n                    width: 50%;\n                    border-top: 2px solid #caa36c;\n                    border-color:inherit;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
